import React from 'react';
import { Button, Stack } from '@mui/material';

import { calendarApi, useCalendar } from '../../api';
import { useDealActivityMutations } from '../../../api';

interface Props {
  selectedIds: string[];
  onClose: VoidFunction;
}

export const BulkActions = ({ selectedIds, onClose }: Props) => {
  const { handleCompleteEvent, isCompleting, handleReDateEvent } = useCalendar();
  const { handleDeleteMultipleDealActivities, isDealActivityDeletingMultiple } = useDealActivityMutations();

  return (
    <Stack direction="row" gap="1rem">
      <Button size="small" variant="text" onClick={() => handleReDateEvent(selectedIds)}>
        Re-date
      </Button>

      <Button
        size="small"
        variant="text"
        loading={isCompleting}
        disabled={isDealActivityDeletingMultiple}
        onClick={async () => {
          await handleCompleteEvent(selectedIds, api => ({
            awaitRefetchQueries: true,
            refetchQueries: [api.dealActivityEventsListing],
          }));

          onClose();
        }}
      >
        Complete
      </Button>

      <Button
        size="small"
        variant="text"
        disabled={isCompleting}
        loading={isDealActivityDeletingMultiple}
        onClick={async () => {
          await handleDeleteMultipleDealActivities({ ids: selectedIds }, () => ({
            awaitRefetchQueries: true,
            refetchQueries: [calendarApi.dealActivityEventsListing],
          }));

          onClose();
        }}
      >
        Delete
      </Button>
    </Stack>
  );
};
